import { Util, DefaultTransitionDuration } from "@ts3d-hoops/web-viewer";

function _filterActiveSheetNodeIds(viewer: any, nodeIds: any) {
  const { model } = viewer;
  const activeSheetId = viewer.sheetManager.getActiveSheetId();
  if (activeSheetId !== null) {
    const sheetParent = model.getNodeParent(activeSheetId);
    const sheets_1 = model.getNodeChildren(sheetParent);
    Util.filterInPlace(nodeIds, (id: any) => {
      let parentId = id;
      while (parentId !== null) {
        if (parentId === activeSheetId) {
          return true;
        }
        if (sheets_1.indexOf(parentId) !== -1) {
          return false;
        }
        parentId = viewer.model.getNodeParent(parentId);
      }
      return true;
    });
  }
}

export default function IsolateZoomHelper(this: any, viewer: any) {
  const _this = this;
  this._camera = null;
  this._deselectOnIsolate = true;
  this._deselectOnZoom = true;
  this._isolateStatus = false;
  this._viewer = viewer;
  this._noteTextManager = this._viewer.noteTextManager;
  this._viewer.setCallbacks({
    modelSwitched() {
      _this._camera = null;
    },
  });
}
IsolateZoomHelper.prototype._setCamera = function (camera: any) {
  if (this._camera === null) {
    this._camera = camera;
  }
};
IsolateZoomHelper.prototype.setDeselectOnIsolate = function (deselect: any) {
  this._deselectOnIsolate = deselect;
};
IsolateZoomHelper.prototype.getIsolateStatus = function () {
  return this._isolateStatus;
};
IsolateZoomHelper.prototype.isolateNodes = function (nodeIds: any, initiallyHiddenStayHidden: any) {
  if (initiallyHiddenStayHidden === void 0) {
    initiallyHiddenStayHidden = null;
  }
  const { view } = this._viewer;
  this._setCamera(view.getCamera());
  _filterActiveSheetNodeIds(this._viewer, nodeIds);
  const p = view.isolateNodes(
    nodeIds,
    DefaultTransitionDuration,
    !this._viewer.sheetManager.isDrawingSheetActive(),
    initiallyHiddenStayHidden,
  );
  // if (this._deselectOnIsolate) {
  //   this._viewer.selectionManager.clear();
  // }
  this._isolateStatus = true;
  return p;
};
IsolateZoomHelper.prototype.fitNodes = function (nodeIds: any) {
  const { view } = this._viewer;
  this._setCamera(view.getCamera());
  const p = view.fitNodes(nodeIds);
  // if (this._deselectOnZoom) {
  //   this._viewer.selectionManager.clear();
  // }
  return p;
};
IsolateZoomHelper.prototype.showAll = function () {
  const { model } = this._viewer;
  if (this._viewer.sheetManager.isDrawingSheetActive()) {
    const sheetId = this._viewer.sheetManager.getActiveSheetId();
    if (sheetId !== null) {
      return this.isolateNodes([sheetId]);
    }
    return Promise.resolve();
  }

  const ps: any[] = [];
  if (model.isDrawing()) {
    // Need to reset 3DNodes here
    const nodes3D = this._viewer.sheetManager.get3DNodes();
    ps.push(this.isolateNodes(nodes3D));
  } else ps.push(model.resetNodesVisibility());
  if (this._camera !== null) {
    this._viewer.view.setCamera(this._camera, DefaultTransitionDuration);
    this._camera = null;
  }
  this._isolateStatus = false;
  ps.push(this._updatePinVisibility());
  return Util.waitForAll(ps);
};
IsolateZoomHelper.prototype._updatePinVisibility = function () {
  this._noteTextManager.setIsolateActive(this._isolateStatus);
  return this._noteTextManager.updatePinVisibility();
};
